export default "\n\n  body * {\n      font-family: inherit ;\n  }\n\n  .LoginRegisterLogin {\n    margin: 20px 0px 0 12px;\n    font-size: 17px;\n  }";